function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 3.2A3.2 3.2 0 013.2 0h9.6A3.2 3.2 0 0116 3.2v9.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 12.8V3.2z",
  fill: "#F5EFFB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 3H4v9h9V3z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#report_advocacy_svg__a)",
  fill: "#8040C9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.576 6.33a.264.264 0 00-.436.102l-.684 2.05-1.03 1.013a1.48 1.48 0 000 2.078c.569.569 1.508.57 2.078 0l.097-.097.446.447a.264.264 0 10.373-.373l-.446-.447.543-.56 2.05-.684a.264.264 0 00.103-.436L6.576 6.329zm-.445 4.87a.923.923 0 01-.658.273.988.988 0 01-.674-.273.952.952 0 010-1.332l.888-.87L7 10.312l-.87.888zm1.314-1.19L5.988 8.555l.517-1.55 2.49 2.49-1.55.517zM10.468 3C9.082 3 7.954 4.145 7.954 5.531a2.516 2.516 0 002.514 2.514c1.386 0 2.53-1.128 2.53-2.514A2.547 2.547 0 0010.469 3zm0 4.517A1.988 1.988 0 018.48 5.531c0-1.095.891-2.004 1.987-2.004 1.095 0 2.004.909 2.004 2.004s-.909 1.986-2.004 1.986z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.76 5.273c-.167-.06-.352-.13-.452-.208-.006-.006-.019-.036-.01-.082.004-.022.023-.094.093-.116.176-.053.257.015.272.03a.264.264 0 00.376-.37.697.697 0 00-.307-.176v-.015a.264.264 0 00-.527 0v.038c-.475.173-.584.821-.222 1.105.159.125.383.214.602.291.13.047.144.14.132.21a.25.25 0 01-.25.213c-.176.002-.218-.005-.346-.089a.264.264 0 10-.289.441c.14.092.252.138.373.159v.025a.264.264 0 00.527 0v-.055c.64-.23.724-1.155.029-1.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "report_advocacy_svg__clip0_1_6"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})));

var SvgReportAdvocacy = function SvgReportAdvocacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#report_advocacy_svg__clip0_1_6)"
  }, _ref, /*#__PURE__*/React.createElement("mask", {
    id: "report_advocacy_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 9,
    height: 9
  }, _ref2), _ref3), _ref4);
};

export default SvgReportAdvocacy;